import ArgonBadge from 'component/Argon/ArgonBadge';

const PendingBadge = (
  <ArgonBadge variant="contained" color="secondary" size="xs" badgeContent="ดำเนินการ" container />
);

const SuccessBadge = (
  <ArgonBadge variant="contained" color="success" size="xs" badgeContent="สำเร็จ" container />
);

const FailedBadge = (
  <ArgonBadge variant="contained" color="error" size="xs" badgeContent="ผิดพลาด" container />
);

const StatusCell = ({ status, isSuccess }) => {
  if (!isSuccess && (status === 'error')) {
    return FailedBadge;
  }
  else if (!isSuccess) {
    return PendingBadge;
  }
  else if (status === 'success' && isSuccess) {
    return SuccessBadge;
  }
  return PendingBadge;
};

export default StatusCell;